const MOTION_FREE = 'free';
const MOTION_LIMITED = 'limited';
const MOTION_LOCKED = 'locked';

export { MOTION_FREE, MOTION_LIMITED, MOTION_LOCKED };
